export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8746.10acc0cb.jpg";